if (!customElements.get('product-ingredients')) {
  class ProductIngredients extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.ingredients__items',
        mobileSwiper: '.ingredients__items-mobile-swiper',
        pagination: '.swiper-pagination',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
      this.mobileSwiper = this.querySelector(this.selectors.mobileSwiper);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = parseInt(this.dataset.items);
      this.tabletItems = parseInt(this.dataset.tabletItems);

      this.sliderInstance = false;
      this.mobileSwiperInstance = false;
      this.isSwipeMobile = this.classList.contains('swipe-mobile');

      // Initialize mobile swiper if available
      if (this.mobileSwiper) {
        this.initMobileSwiper();
      }

      if (!this.enableSlider) return;

      this.init();
      document.addEventListener('matchMobile', () => {
        this.init();
      });
      document.addEventListener('unmatchMobile', () => {
        this.init();
      });
    }

    initMobileSwiper() {
      // Find navigation buttons in parent container
      const parent = this.parentElement;
      const nextBtn = parent?.querySelector(this.selectors.nextEl);
      const prevBtn = parent?.querySelector(this.selectors.prevEl);

      const columnGap = parseInt(this.style.getPropertyValue('--column-gap') || '32');

      const mobileSwiperOptions = {
        slidesPerView: 'auto',
        spaceBetween: columnGap,
        navigation: nextBtn && prevBtn ? {
          nextEl: nextBtn,
          prevEl: prevBtn,
        } : false,
        pagination: false,
        loop: false,
        watchOverflow: true,
        threshold: 2,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
      };

      if (typeof this.mobileSwiperInstance !== 'object') {
        this.mobileSwiperInstance = new window.FoxTheme.Carousel(this.mobileSwiper, mobileSwiperOptions);
        this.mobileSwiperInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this.mobileSwiper);
        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.mobileSwiperInstance.slider.slideTo(this.mobileSwiperInstance.slider.slides.indexOf(slide));
          });
        });
      }
    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        // Check if mobile arrows are enabled
        const showArrowsMobile = this.dataset.showArrowsMobile === 'true';
        if (showArrowsMobile) {
          this.initSlider();
        } else {
          this.destroySlider();
        }
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      // Desktop slider only - mobile uses separate swiper structure
      if (!this.sliderWrapper) return;

      const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);

      // Find navigation buttons in parent container
      const parent = this.parentElement;
      const nextBtn = parent?.querySelector(this.selectors.nextEl);
      const prevBtn = parent?.querySelector(this.selectors.prevEl);

      const sliderOptions = {
        slidesPerView: 2,
        spaceBetween: columnGap.tablet,
        navigation: nextBtn && prevBtn ? {
          nextEl: nextBtn,
          prevEl: prevBtn,
        } : false,
        pagination: false,
        breakpoints: {
          1280: {
            slidesPerView: 3,
            spaceBetween: columnGap.desktop
          },
        },
        loop: false,
        watchOverflow: true,
        threshold: 2,
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });
      }
      if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          let { target } = e;
          const index = Number(target.dataset.index);

          this.sliderInstance.slider.slideToLoop(index);
        });
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  }
  customElements.define('product-ingredients', ProductIngredients);
}
